var z = Object.defineProperty, S = Object.defineProperties;
var w = Object.getOwnPropertyDescriptors;
var s = Object.getOwnPropertySymbols;
var j = Object.prototype.hasOwnProperty, g = Object.prototype.propertyIsEnumerable;
var b = (n, t, a) => t in n ? z(n, t, { enumerable: !0, configurable: !0, writable: !0, value: a }) : n[t] = a, l = (n, t) => {
  for (var a in t || (t = {}))
    j.call(t, a) && b(n, a, t[a]);
  if (s)
    for (var a of s(t))
      g.call(t, a) && b(n, a, t[a]);
  return n;
}, d = (n, t) => S(n, w(t));
var m = (n, t) => {
  var a = {};
  for (var e in n)
    j.call(n, e) && t.indexOf(e) < 0 && (a[e] = n[e]);
  if (n != null && s)
    for (var e of s(n))
      t.indexOf(e) < 0 && g.call(n, e) && (a[e] = n[e]);
  return a;
};
import { j as c } from "../../../jsx-runtime-c20f6c15.mjs";
import B from "clsx";
import { forwardRef as C } from "react";
import P from "../Spinner/Spinner.mjs";
const V = "_button_17sqj_8", A = "_disabled_17sqj_26", L = "_primary_17sqj_35", M = "_secondary_17sqj_36", O = "_tertiary_17sqj_37", R = "_spinner_17sqj_7", k = "_outlined_17sqj_54", D = "_large_17sqj_127", E = "_medium_17sqj_131", i = {
  button: V,
  disabled: A,
  primary: L,
  secondary: M,
  tertiary: O,
  spinner: R,
  outlined: k,
  large: D,
  medium: E
};
function F(n) {
  return typeof n.href == "string";
}
const G = {
  medium: "xSmall",
  large: "small"
};
function H(n, t) {
  const {
    loading: a = !1,
    disabled: e = !1,
    plain: u = !1,
    variant: r = "primary",
    size: o = "medium",
    children: _,
    className: q,
    outlined: N = !1
  } = n, p = B(
    i.button,
    !u && {
      [i.primary]: r === "primary",
      [i.secondary]: r === "secondary",
      [i.tertiary]: r === "tertiary",
      [i.medium]: o === "medium",
      [i.large]: o === "large"
    },
    (a || e) && i.disabled,
    N && i.outlined,
    q
  );
  if (F(n)) {
    const y = n, { plain: T, plain: U, variant: W } = y, v = m(y, ["plain", "plain", "variant"]);
    return /* @__PURE__ */ c("a", d(l({ ref: t }, v), { className: p, children: _ }));
  }
  const f = n, {
    type: h = "button",
    plain: I,
    variant: J,
    loading: K,
    outlined: Q
  } = f, x = m(f, [
    "type",
    "plain",
    "variant",
    "loading",
    "outlined"
  ]);
  return /* @__PURE__ */ c(
    "button",
    d(l({
      ref: t,
      disabled: a || e,
      type: h
    }, x), {
      className: p,
      children: !u && a ? /* @__PURE__ */ c(P, { className: i.spinner, size: G[o] }) : _
    })
  );
}
const tn = C(H);
export {
  tn as default
};
